import React from 'react';
import './LoiIch.css';

const LoiIch = () => {
  const benefits = [
    {
      icon: '🎁',
      title: 'Quay số miễn phí',
      description: 'Mỗi ngày 1 lượt quay không mất phí, không cần nạp tiền. Chơi ngay để trúng thưởng!'
    },
    {
      icon: '⚡',
      title: 'Rút tiền tức thì',
      description: 'Trúng thưởng là nhận tiền ngay. Rút về tài khoản trong 5 phút, không cần chờ đợi.'
    },
    {
      icon: '🎯',
      title: 'Tỷ lệ trúng cao',
      description: 'Cứ 8 người chơi thì có 1 người trúng. Cơ hội trúng thưởng lên đến 12.5% mỗi lượt quay.'
    },
    {
      icon: '🛡️',
      title: 'Đảm bảo uy tín',
      description: 'Được cấp phép hoạt động, bảo mật thông tin SSL, hỗ trợ khách hàng 24/7 qua Zalo, Facebook.'
    }
  ];

  return (
    <section className="benefits">
      <div className="container">
        <h2 className="section-title">Vì Sao Nên Chơi Game May Mắn Của Chúng Tôi?</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">{benefit.icon}</div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LoiIch;

